import type { ComponentType } from "react";

const REACT_EXOTIC_COMPONENT_TYPES = new Set<symbol>([
  Symbol.for("react.memo"),
  Symbol.for("react.lazy"),
]);

// React.memo and lazy return objects at runtime, even though React can render
// each one wherever it accepts a component type.
export const isRouteComponentExport = (
  value: unknown,
): value is ComponentType =>
  typeof value === "function" ||
  (typeof value === "object" &&
    value !== null &&
    "$$typeof" in value &&
    typeof value.$$typeof === "symbol" &&
    REACT_EXOTIC_COMPONENT_TYPES.has(value.$$typeof));
